import React, { useState, useEffect } from 'react';
import FileUploadComponent from './FileUploadComponent';
import DashboardLayout from '../layout/DashboardLayout';
import '../../styles/FileSharing.css';

const FileSharing = () => {
  const [files, setFiles] = useState([]);
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const response = await fetch('https://clinic123.onrender.com/api/files', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      if (response.ok) {
        setFiles(data);
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };

  const handleDownload = async (fileId, fileName) => {
    try {
      const response = await fetch(`https://clinic123.onrender.com/api/files/${fileId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleDelete = async (fileId) => {
    if (!window.confirm('Are you sure you want to delete this file?')) return;
    try {
      const response = await fetch(`https://clinic123.onrender.com/api/files/${fileId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        fetchFiles();
      }
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  return (
    <DashboardLayout pageTitle="File Sharing">
      <div className="upload-section card">
        <h3>Upload New File</h3>
        <FileUploadComponent userId={userId} onUploadSuccess={fetchFiles} />
      </div>
      <div className="files-list card">
        <h3>Shared Files</h3>
        <div className="files-grid">
          {files.map((file) => (
            <div key={file._id} className="file-card">
              <div className="file-icon">
                <i className="fas fa-file"></i>
              </div>
              <div className="file-info">
                <h4>{file.name}</h4>
                <p>Uploaded by: {file.uploadedBy?.name || file.uploadedBy?.email || "Unknown"}</p>
                <p>Date: {new Date(file.uploadDate).toLocaleDateString()}</p>
              </div>
              <div className="file-actions">
                <button
                  onClick={() => handleDownload(file._id, file.name)}
                  className="download-button"
                >
                  Download
                </button>
                <button
                  onClick={() => handleDelete(file._id)}
                  className="delete-button"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default FileSharing;
